Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.exampleAPiEndPoint = "EXAMPLE_URL";
exports.examplePostAPiMethod = "POST";
exports.exampleGetAPiMethod = "GET";
exports.exampleApiContentType = "application/json";
exports.textInputPlaceHolder = "Enter Text";
exports.labelTitleText = "ReportScheduler";
exports.labelBodyText = "ReportScheduler Body";
exports.bodyText = "bodyText";
exports.titleText = "titleText";
exports.inputText = "inputTextTitle";
exports.pageTitle = "Report Scheduler";

exports.btnExampleTitle = "CLICK ME";
// Customizable Area End
